import utils from '../utils';

const tasks = {
	get_task_data: (requested_body: any, signal: any) => {
		return utils.request({
			url: 'crm/v1/task-ssrm/s/search',
			method: 'POST',
			data: requested_body,
			signal,
		});
	},

	get_task_list: (requested_body: any) => {
		return utils.request({
			url: 'crm/v1/task-ssrm/search',
			method: 'POST',
			data: requested_body,
		});
	},

	get_filter_facets: (requested_body: any) => {
		return utils.request({
			url: 'crm/v1/task-ssrm/s/facets',
			method: 'POST',
			data: requested_body,
		});
	},

	create_task: (requested_body: any) => {
		return utils.request({
			url: 'crm/v1/task',
			method: 'POST',
			data: requested_body,
		});
	},

	delete_task: (task_id: string) => {
		return utils.request({
			url: `crm/v1/task/${task_id}`,
			method: 'DELETE',
		});
	},

	update_task: (task_id: string, requested_body: any) => {
		return utils.request({
			url: `crm/v1/task/${task_id}`,
			method: 'PUT',
			data: requested_body,
		});
	},

	get_task_form: () => {
		return utils.request({
			url: 'setting/v1/configuration/tenant_or_default/task_form',
			method: 'GET',
		});
	},

	get_buyer_sales_rep_list: () => {
		return utils.request({
			url: 'buyer/v2/account/search/users',
			method: 'GET',
		});
	},
	get_buyer_sales_rep_list_by_id: (task_id: string) => {
		return utils.request({
			url: `buyer/v2/account/search/users?buyer_id=${task_id}`,
			method: 'GET',
		});
	},

	get_task_form_id: (task_id: string) => {
		return utils.request({
			url: `crm/v1/task/form/${task_id}`,
			method: 'GET',
		});
	},

	get_task_details: (task_id: string) => {
		return utils.request({
			url: `crm/v1/task/${task_id}`,
			method: 'GET',
			show_error: false,
		});
	},

	//comments
	get_comments_by_id: (task_id: string, offset: number) => {
		return utils.request({
			url: `/crm/v1/comment/${task_id}?limit=5&offset=${offset}`,
			method: 'GET',
		});
	},
	add_comment: (data: any) => {
		return utils.request({
			url: '/crm/v1/comment',
			method: 'POST',
			data,
		});
	},
	update_comment: (data: any) => {
		return utils.request({
			url: '/crm/v1/comment',
			method: 'PUT',
			data,
		});
	},
	delete_comment: (id: string) => {
		return utils.request({
			url: `/crm/v1/comment/${id}`,
			method: 'DELETE',
		});
	},

	//ai
	ai_extract_details: (data: any) => {
		return utils.request({
			url: '/crm/v1/ai/extract_details',
			method: 'POST',
			data,
		});
	},

	ai_auto_complete: (data: any) => {
		return utils.request({
			url: '/crm/v1/ai/completion',
			method: 'POST',
			data,
		});
	},

	ai_chat_completions: (data: any) => {
		return utils.request({
			url: '/crm/v1/ai/chat/completions',
			method: 'POST',
			data,
		});
	},
};

export default tasks;
